export function TenthSection(props: Array<{
    text: string
}>) {
    return (
        <div className="landing-tenth-section" dangerouslySetInnerHTML={{ __html: props[0].text }} />
    );
}